import { useEffect } from "react";
import { useUtilsStore } from "../../../../stores/Utils/selects";
import { getStates } from "../../../../services/Api/stateService";
import { showToastError } from "../../../../services/Toasts/toasts";

const SelectState = () => {
  const { states, setStates, selectedState, setSelectedState } =
    useUtilsStore();

  useEffect(() => {
    getStates()
      .then((data) => {
        const stateWithoutPending = data.filter((state: any) => state.id !== 4);
        setStates(stateWithoutPending);
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  }, []);

  return (
    <select
      name="state"
      id="state"
      onChange={(e) => {
        setSelectedState(parseInt(e.target.value));
      }}
      value={selectedState}
      className="w-44 pr-4 py-2 border border-gray-200 text-md rounded-xl bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm hover:shadow-md focus:shadow-lg font-medium search-input"
      >
      {selectedState === 0 && <option value="">Choisir un état</option>}
      {states?.map((state) => (
        <option value={state?.id} key={state?.id}>
          {state?.state}
        </option>
      ))}
    </select>
  );
};

export default SelectState;
